module.exports = __webpack_public_path__ + "img/img_ren@2x.f17e97fe.png";